import { Observable, of } from 'rxjs'
import { catchError, merge, switchMap } from 'rxjs/operators'

import { Task } from '@skinsoft/types'
import { taskSelectors } from '@skinsoft/selectors'
import { HistoryRecord } from '@skinsoft/ui'
import { resolveAuthor } from '../../resolve-author'
import { resolveDescription } from './resolve-description'

export function toHistoryRecord$(task: Task, locale): Observable<HistoryRecord> {
    const featured: HistoryRecord = {
        author: taskSelectors.author(task),
        date: taskSelectors.endDate(task),
        description: taskSelectors.associatedTasks(task)[0],
        id: task.id,
        // @ts-ignore
        title: taskSelectors.incrementalTitle(task),
    };

    const featured$ = of(featured);

    const resolveDescription$  = (resolveDescription(featured$, locale) as Observable<HistoryRecord>).pipe(
        catchError(error => of({...featured, description: ''}))
    )

    return resolveDescription$.pipe(
        switchMap(res => {
            return (resolveAuthor(of(res)) as Observable<HistoryRecord>).pipe(
                catchError(error => of({ ...res, author: null }))
            )
        }),
    )
}
